


import React, { useState, useEffect } from 'react';
import {
  MessageSquare, X, Send, User, TrendingUp, Building
} from 'lucide-react';
import Whasappicon from '../../../../Assets/InforPage/whatsappIcon.png'
const OdooLandingPage = ({contact}) => {
  const [isVisible, setIsVisible] = useState({});
  const [showWhatsAppDialog, setShowWhatsAppDialog] = useState(false);
  const [whatsAppMessage, setWhatsAppMessage] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      id: 1,
      title: 'CRM',
      color: '#6366F1',
      bgColor: '#F0F2FF',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/crm.png?updatedAt=1750049831551'
    },
    {
      id: 2,
      title: 'Accounting',
      color: '#10B981',
      bgColor: '#ECFDF5',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/task-management.png?updatedAt=1750049831547'
    },
    {
      id: 3,
      title: 'Manufacturing',
      color: '#EF4444',
      bgColor: '#FEF2F2',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/manufacturing.png?updatedAt=1750049831614'
    },
    {
      id: 4,
      title: 'Inventory',
      color: '#3B82F6',
      bgColor: '#EFF6FF',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/material-management.png?updatedAt=1750049831644'
    },
    {
      id: 5,
      title: 'eCommerce',
      color: '#F59E0B',
      bgColor: '#FFFBEB',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/online-shopping.png?updatedAt=1750049831627'
    },
    {
      id: 6,
      title: 'HR',
      color: '#8B5CF6',
      bgColor: '#F3E8FF',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/HR.png?updatedAt=1750049831685'
    },
    {
      id: 7,
      title: 'Sales',
      color: '#06B6D4',
      bgColor: '#F0F9FF',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/sales.png?updatedAt=1750049831547'
    },
    {
      id: 8,
      title: 'Website',
      color: '#14B8A6',
      bgColor: '#F0FDFA',
      image: 'https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/ux.png?updatedAt=1750049831567'
    }
  ];

  const handleWhatsAppOpen = () => {
    setShowWhatsAppDialog(true);
  };
    
  const handledowntocontact = () => {
    contact.current.scrollIntoView({ behavior: 'smooth' });
  }
  const handleWhatsAppSend = () => {
    const message = whatsAppMessage || 'Hello! I am interested in your Odoo implementation services.';
    const phoneNumber = '9154673864'; 
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setShowWhatsAppDialog(false);
    setWhatsAppMessage('');
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden relative" style={{ background: 'linear-gradient(135deg, #F8FAFC 0%, #FFFFFF 50%, #FAF5FF 100%)' }}>
      {/* WhatsApp Dialog */}
      {showWhatsAppDialog && (
        <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50 p-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 transform animate-scale-in" style={{ border: '1px solid #F3F4F6' }}>
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)' }}>
                  <MessageSquare className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold" style={{ color: '#1F2937' }}>WhatsApp Contact</h3>
                  <p className="text-sm" style={{ color: '#6B7280' }}>Send us a message</p>
                </div>
              </div>
              <button
                onClick={() => setShowWhatsAppDialog(false)}
                className="w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                style={{ backgroundColor: '#F3F4F6' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#E5E7EB'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#F3F4F6'}
              >
                <X className="w-5 h-5" style={{ color: '#6B7280' }} />
              </button>
            </div>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold mb-3" style={{ color: '#374151' }}>
                  Your Message
                </label>
                <textarea
                  value={whatsAppMessage}
                  onChange={(e) => setWhatsAppMessage(e.target.value)}
                  placeholder="Hello! I am interested in your Odoo implementation services."
                  className="w-full px-4 py-4 rounded-xl resize-none transition-all duration-200"
                  style={{ 
                    border: '1px solid #E5E7EB',
                    focusBorderColor: '#10B981'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#10B981';
                    e.target.style.boxShadow = '0 0 0 3px rgba(16, 185, 129, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#E5E7EB';
                    e.target.style.boxShadow = 'none';
                  }}
                  rows="4"
                />
              </div>
              
              <div className="flex space-x-4">
                <button
                  onClick={() => setShowWhatsAppDialog(false)}
                  className="flex-1 px-6 py-3 rounded-xl font-medium transition-colors"
                  style={{ 
                    border: '1px solid #E5E7EB',
                    color: '#6B7280',
                    backgroundColor: 'transparent'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#F9FAFB'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Cancel
                </button>
                <button
                  onClick={handleWhatsAppSend}
                  className="flex-1 px-6 py-3 text-white rounded-xl font-medium transition-all duration-200 flex items-center justify-center space-x-2 shadow-lg"
                  style={{ background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)' }}
                  onMouseEnter={(e) => e.target.style.background = 'linear-gradient(90deg, #059669 0%, #047857 100%)'}
                  onMouseLeave={(e) => e.target.style.background = 'linear-gradient(90deg, #10B981 0%, #059669 100%)'}
                >
                  <Send className="w-4 h-4" />
                  <span>Send</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main className="container mx-auto px-6 py-2 ml-10 max-w-7xl">
        <div className="grid lg:grid-cols-2 gap-20 items-center min-h-[85vh]">
          {/* Left Content */}
          <div
            id="main-content"
            data-animate
            className={`space-y-8 ${isVisible['main-content'] ? 'animate-fade-in-up' : 'opacity-0'}`}
          >
            <div className="space-y-4">
              <h1 className="text-6xl lg:text-7xl font-bold leading-[0.9] tracking-tight">
                <span
                  className="bg-clip-text text-transparent block text-4xl lg:text-5xl text-[#7d2064]"
                 
                >
                KCS Tech  Odoo
                </span>
                <div className="flex flex-row gap-2">
                <p className="block text-gray-800 text-3xl lg:text-4xl text-[#714B67]">Implementation</p>
                <p className="text-3xl lg:text-4xl block font-medium" style={{ color: '#750426' }}>Services</p>
                </div>
              </h1>
            </div>

            {/* Gradient Line */}
            <div
              className="w-32 h-2 rounded-full shadow-lg"
              style={{
                background: 'linear-gradient(90deg, #6366F1 0%, #8B5CF6 50%, #EC4899 100%)',
              }}
            ></div>

    <p
  className="text-base sm:text-lg md:text-lg -webkit-line-clamp:50"
  style={{
    color: 'black',
    wordBreak: 'normal',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    maxWidth: '40rem', // ~640px, adjust as needed
    lineHeight: '1.6'
   
              }}
              
            >
             
             KCS Tech is trusted partner for your  Odoo consulting services , and we specialized in Odoo Implementation services to grow your business very efficiently. We have customized ERP solutions for managing and integrating various business functions with efficiency to achieve the strategic goals. 

</p>

            <div className="pt-6">
              <button
                 onClick={(e)=> handledowntocontact(e)}
                className="group ml-10 text-white px-4 py-4 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 flex items-center space-x-3"
                style={{ background: 'linear-gradient(90deg, #6366F1 0%, #8B5CF6 100%)' }}
                onMouseEnter={(e) => e.target.style.background = 'linear-gradient(90deg, #4F46E5 0%, #7C3AED 100%)'}
                onMouseLeave={(e) => e.target.style.background = 'linear-gradient(90deg, #6366F1 0%, #8B5CF6 100%)'}
              >
                <span>Get Started Today</span>
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center group-hover:rotate-45 transition-transform duration-300">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
              </button>
            </div>
          </div>

          {/* Fixed Circular Services Section */}
          <div 
            id="services-circle"
            data-animate
            className={`relative flex items-center justify-center ${isVisible['services-circle'] ? 'animate-fade-in-right' : 'opacity-0'}`}
          >
            <div className="relative w-[400px] h-[400px]">
              {/* Center Odoo Logo */}
              <div className="absolute lg:top-1/2 md:top-1/4  sm:top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-30">
                <div 
                  className="w-24 h-24 rounded-2xl shadow-2xl flex flex-col items-center justify-center"
                  style={{
                    background: 'linear-gradient(135deg, #714B67 0%, #A24689 50%, #714B67 100%)',
                    border: '4px solid #FFFFFF'
                  }}
                >
                  <div className="text-center text-white">
                    <div className="text-lg font-black">Odoo</div>
                    <div className="text-md opacity-90 font-medium">ERP</div>
                  </div>
                </div>
              </div>

              {/* Corrected Orbital Container */}
              <div className="absolute lg:top-1/2 md:top-1/4 sm:top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div className="relative w-[300px] h-[300px]">
                  <div className="absolute inset-0 animate-rotate-slow" style={{ transformOrigin: "center center" }}>
                    {services.map((service, index) => {
                      const totalServices = services.length;
                      const angleStep = 360 / totalServices;
                      const angle = (index * angleStep);
                      const angleRad = (angle * Math.PI) / 180;
                      const radius = 130;
                      
                      const x = 150 + (Math.cos(angleRad) * radius);
                      const y = 150 + (Math.sin(angleRad) * radius);

                      return (
                        <div
                          key={service.id}
                          className="absolute"
                          style={{
                            left: `${x}px`,
                            top: `${y}px`,
                            transform: 'translate(-50%, -50%)'
                          }}
                        >
                          <div className="animate-counter-rotate" style={{ transformOrigin: "center center" }}>
                            <div 
                              className="w-16 h-16 rounded-xl shadow-xl flex items-center justify-center cursor-pointer transform hover:scale-110 transition-all duration-300 hover:shadow-2xl group"
                              style={{ 
                                backgroundColor: service.bgColor,
                                border: '3px solid #FFFFFF',
                                boxShadow: `0 8px 25px ${service.color}25`
                              }}
                            >
                              <img 
                                src={service.image} 
                                alt={service.title}
                                className="w-8 h-8 object-contain group-hover:scale-110 transition-transform duration-300"
                              />
                            </div>
                            <div 
                              className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-xs font-bold whitespace-nowrap px-2 py-1 rounded-lg shadow-lg backdrop-blur-sm"
                              style={{ 
                                color: service.color,
                                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                                border: '2px solid #FFFFFF'
                              }}
                            >
                              {service.title}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

             

              {/* Floating Particles */}
              <div className="absolute inset-0 overflow-hidden pointer-events-none">
                {[...Array(8)].map((_, i) => (
                  <div
                    key={i}
                    className="absolute rounded-full animate-float opacity-60"
                    style={{
                      width: `${4 + (i % 3) * 2}px`,
                      height: `${4 + (i % 3) * 2}px`,
                      background: `linear-gradient(45deg, ${i % 2 === 0 ? '#714B67' : '#A24689'}, ${i % 2 === 0 ? '#A24689' : '#EC4899'})`,
                      left: `${15 + (i * 10)}%`,
                      top: `${10 + (i * 10)}%`,
                      animationDelay: `${i * 0.5}s`,
                      animationDuration: `${5 + (i * 0.3)}s`,
                      boxShadow: `0 0 8px ${i % 2 === 0 ? '#714B67' : '#A24689'}50`
                    }}
                  />
                ))}
              </div>

              {/* Background Glow */}
              <div 
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 rounded-full blur-3xl -z-10 opacity-20"
                style={{ background: 'linear-gradient(45deg, #E879F9, #F472B6)' }}
              ></div>
            </div>
          </div>
        </div>
      </main>

      {/* Enhanced WhatsApp Button */}
      <div className="fixed bottom-8 left-8 z-50">
        <button
          onClick={handleWhatsAppOpen}
          className="relative w-18 h-18 bg-gradient-to-br from-green-400 to-green-600 text-white rounded-2xl shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 group border-4 border-white"
        >
          <img src={Whasappicon} alt="Contact KCS Tech for Odoo Services"  className="w-12 h-12 mx-auto" />
          {/* <MessageSquare className="w-8 h-8 mx-auto" /> */}
          <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-r from-red-400 to-red-600 rounded-full flex items-center justify-center shadow-lg">
            <span className="text-xs text-white font-bold">1</span>
          </div>
          <div className="absolute inset-0 rounded-2xl bg-green-400 opacity-0 group-hover:opacity-30 transition-opacity duration-300 animate-ping"></div>
        </button>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(60px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fade-in-right {
          from {
            opacity: 0;
            transform: translateX(60px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes rotate-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes counter-rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-360deg);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px) scale(1);
          }
          25% {
            transform: translateY(-20px) translateX(10px) scale(1.1);
          }
          50% {
            transform: translateY(-10px) translateX(-10px) scale(0.9);
          }
          75% {
            transform: translateY(-25px) translateX(5px) scale(1.05);
          }
        }

        @keyframes scale-in {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes pulse-slow {
          0%, 100% {
            opacity: 0.3;
          }
          50% {
            opacity: 0.6;
          }
        }

        .animate-fade-in-up {
          animation: fade-in-up 1.2s ease-out forwards;
        }

        .animate-fade-in-right {
          animation: fade-in-right 1.2s ease-out forwards;
        }

        .animate-rotate-slow {
          animation: rotate-slow 25s linear infinite;
          transform-origin: center center;
        }

        .animate-counter-rotate {
          animation: counter-rotate 25s linear infinite;
          transform-origin: center center;
        }

        .animate-float {
          animation: float ease-in-out infinite;
        }

        .animate-scale-in {
          animation: scale-in 0.4s ease-out forwards;
        }

        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }

        /* Enhanced focus styles */
        input:focus, textarea:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
        }

        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* Custom scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
        }

        ::-webkit-scrollbar-track {
          background: #f1f5f9;
        }

        ::-webkit-scrollbar-thumb {
          background: linear-gradient(135deg, #6366F1, #8B5CF6);
          border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(135deg, #4F46E5, #7C3AED);
        }
      `}</style>
    </div>
  );
};

export default OdooLandingPage;
